<template>
  <b-dropdown class="ml-lg-2" no-caret variant="btn">
    <template slot="button-content">
      <span>
        <i class="fa fa-2x fa-user text-primary"></i>
      </span>
    </template>
    <b-dropdown-item v-if="!isLoggedIn" class="text-center px-0" @click="$store.dispatch('auth/showModal')">
      <span role="button">{{ $_t('KW:login') }}</span>
    </b-dropdown-item>

    <!-- <b-dropdown-item v-if="isLoggedIn && !isUserVerified" class="text-center px-0" @click="$store.dispatch('auth/showModal')">
      <span role="button">{{ $_t('KW:verify') }}</span>
    </b-dropdown-item> -->

    <b-dropdown-item v-if="isLoggedIn" class="text-center px-0" @click="$router.push('/profile')">
      <span role="button">Profile</span>
    </b-dropdown-item>

    <b-dropdown-item v-if="isLoggedIn" class="text-center px-0" @click="$store.dispatch('auth/logout')">
      <span>
        <i class="fa fa-sign-out"></i>
      </span>
      <span role="button">Logout</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
    }),
  },
};
</script>

<style>
</style>